import * as React from 'react'
import {ResponsiveValue} from '../..'
import Box from '../layout/Box'

const Plus: React.FC<{
  width?: ResponsiveValue<string | number>
  height?: ResponsiveValue<string | number>
}> = ({width = 24, height = 24, ...props}) => {
  return (
    <Box
      as="svg"
      $styles={{width, height}}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="#050038">
        <rect x={11} y={5} width={2} height={14} rx={1} />
        <rect x={5} y={13} width={2} height={14} rx={1} transform="rotate(-90 5 13)" />
      </g>
    </Box>
  )
}

export default Plus
